var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorChip1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.3333,
    height: 21.3333,
    viewBox: "0 0 21.3333 21.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rest"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.074 14.807C16.3307 15.0654 15.5428 15.1695 14.7579 15.113C13.973 15.0565 13.2078 14.8406 12.5093 14.4783C11.8107 14.116 11.1934 13.615 10.695 13.006C10.1967 12.397 9.8277 11.6928 9.61079 10.9364C9.39389 10.1799 9.33365 9.38722 9.43356 8.60668C9.53347 7.82613 9.79146 7.07409 10.1919 6.39668C10.5923 5.71926 11.1268 5.13068 11.7625 4.66683C12.3981 4.20298 13.1216 3.87371 13.8888 3.69905C14.3631 3.56415 14.4968 2.86151 14.0245 2.71989C13.5654 2.58219 13.094 2.48409 12.6157 2.42724C11.5072 2.29552 10.3835 2.38819 9.31153 2.69979C7.27199 3.28462 5.54846 4.65561 4.51982 6.51132C3.49118 8.36703 3.2417 10.5554 3.82653 12.595C4.41136 14.6345 5.78262 16.3582 7.63833 17.3868C9.49403 18.4155 11.6822 18.6648 13.7217 18.08C14.7959 17.7762 15.798 17.2593 16.6683 16.5602C17.0438 16.2585 17.3915 15.9255 17.7079 15.5654C18.0334 15.1951 17.5476 14.6701 17.074 14.807Z",
    fill: "#14CD71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorChip1);
export default __webpack_public_path__ + "static/media/behavior-chip-1.593d0c590064d38b81d44a0d2326d03f.svg";
export { ForwardRef as ReactComponent };